// extracted by mini-css-extract-plugin
module.exports = {"detailModal":"ModalBase_detailModal__yyeTW","content":"ModalBase_content__YCZvr","drawer":"ModalBase_drawer__UFeRW","drawerCloseButton":"ModalBase_drawerCloseButton__sego4"};